const testimonials = [
  {
    author: 'Tachi Rivera',
    authorTitle: 'Product Manager, Bit Systems',
    quote: "Nathan was a key player on our team. He came in knowing absolutely nothing about the customer and did a deep dive to understand the problems at hand and to assist in generating a more usable interface.  He continues to assist with debug and 'tweaks' to keep the customer happy and the baseline stable.",
    image: 'images/testimonials/tachi.png',
  },
  {
    author: 'Cameron Castells',
    authorTitle: 'Web Developer, INEO',
    quote: "Nathan exemplifies a hard work ethic and is incredibly creative. Once he decides to accomplish something, he has the talent and mindset to get the job done. On top of that, he's a joy to work with.",
    image: 'images/testimonials/cam.png',
  },
  {
    author: 'Cthulhu',
    authorTitle: "Elder God of R'lyeh",
    quote: "Iä! Iä! Cthulhu fhtagn! Ph'nglui mglw'nfah Cthulhu R'lyeh wgah'nagl fhtagn!",
    image: 'images/testimonials/cthulhu.png'
  },
]

export default testimonials



// WEBPACK FOOTER //
// ./src/components/Main/About/testimonials.js